import { EnvironmentType } from "../../../../modules/environment/envTypes"
import { UserType } from "../../../../modules/login/loginTypes"

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}

// Where unfinished features (filters and pages whose backend is not live yet) are still shown: everywhere but QA/prod.
export const UNFINISHED_FEATURE_ENVIRONMENTS = [EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]

// The merchants list endpoint answers 404 for companies and 405 for support, so the merchant filter is unfinished for them.
export const USER_TYPES_WITHOUT_MERCHANTS_ENDPOINT: ReadonlyArray<UserType> = [UserType.COMPANY, UserType.SUPPORT]
